import '@babel/polyfill';
import Vue from 'vue';
import Amplify from 'aws-amplify';
import API from '@aws-amplify/api';
import App from './App.vue';
import router from './router';
import store from './store';
import './services/projects';
import './services/player';
import './services/metrics';
import './plugins/vuetify';
import './custom.css';
import '@/utils/downlink';

Vue.config.productionTip = false;

API.configure({
  endpoints: [
    {
      name: 'esite',
      endpoint: `${process.env.VUE_APP_API_BASE_URL}`,
    },
  ],
});

Amplify.Logger.LOG_LEVEL = process.env.VUE_APP_LOG_LEVEL;

Vue.prototype.$eventHub = new Vue();

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
